import { Box, Button, FormHelperText } from '@mui/material'
import ResetAllDialog from './ResetAllDialog'
import React, { useState } from 'react'
import { Warning } from '@mui/icons-material'

function ResetAllSettings() {
  const [openReset, setOpenReset] = useState(false)
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
    >
      <Button
        aria-label={'Reset All Settings'}
        variant="outlined"
        color="error"
        onClick={() => setOpenReset(true)}
        sx={{ mt: 2 }}
        startIcon={<Warning />}
      >
        Reset All Settings
      </Button>
      <FormHelperText>
        All saved preference and stored data will be reset to default values
        upon next page refresh.
      </FormHelperText>
      <ResetAllDialog
        open={openReset}
        setOpen={setOpenReset}
      />
    </Box>
  )
}
export default ResetAllSettings
